type BuildCognitoLogoutUrlInput = {
    domain: string;
    clientId: string;
    origin: string;
};

// logout_uri must exactly match a registered logoutUrls entry — that list is built from
// getAdminAuthSignInUrl, which resolves to `<site>/sign-in` on every stage.
export function buildCognitoLogoutUrl({
    domain,
    clientId,
    origin,
}: BuildCognitoLogoutUrlInput): string {
    const logoutUri = `${origin}/sign-in`;
    return `https://${domain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
}
